var Common = {
  currentUser: JSON.parse(localStorage.getItem('userData')),
  isOn: localStorage.getItem('isOn'),
  baseUrl: 'https://mt.centremedvie.com/',
  baseApiUrl: 'https://mt.centremedvie.com/api/'
};
export default Common;